import { render, staticRenderFns } from "./message-room-default.vue?vue&type=template&id=2d9bc14c&scoped=true"
import script from "./message-room-default.vue?vue&type=script&lang=ts"
export * from "./message-room-default.vue?vue&type=script&lang=ts"
import style0 from "./message-room-default.vue?vue&type=style&index=0&id=2d9bc14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9bc14c",
  null
  
)

export default component.exports